import {useState} from "react";

const useFilterUser = () => {
    const [query, setQuery] = useState("")

    const getQueryNoWhiteSpace = (query) => {
       return query.toLowerCase().replace(/\s+/g, '')
    }
    const getFullNameNoWhiteSpace = (user) => {
        return user.firstName.toLowerCase() + user.lastName.toLowerCase().replace(/\s+/g, '')
    }
    const getFullNameInverseNoWhiteSpace = (user) => {
        return user.lastName.toLowerCase() + user.firstName.toLowerCase().replace(/\s+/g, '')
    }


    return {
        getFullNameInverseNoWhiteSpace,
        getFullNameNoWhiteSpace,
        getQueryNoWhiteSpace,

        query,
        setQuery
    }
}

export default useFilterUser;